/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingDoctolibInboundAppointmentPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const BookingDoctolibInboundAppointmentPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingDoctolibInboundAppointmentPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingDoctolibInboundAppointmentPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingDoctolibInboundAppointmentPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


